import React from 'react';
import { Button, Typography, useMediaQuery } from "@mui/material";
import { Apple, Android } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { LINKS } from '../../constants/links';

const DownloadButton = () => {
  const mobileView = useMediaQuery('(min-width:768px)');
  const { t } = useTranslation();

  return (
    <Button 
      variant="outlined" 
      color="primary" 
      href={LINKS.GLFR_APP_DOWNLOAD}
      style={{
        borderRadius: 15, 
        color: 'white', 
        borderColor: 'white'
      }}
    >
      {mobileView ? (
        <Typography style={{fontWeight: 'bold'}}>
          {`${t('download')} GLFR`}
        </Typography>
      ) : (
        <>
          <Typography style={{marginRight: 10}}>GLFR</Typography>
          <Apple/>
          <Android/>
        </>
      )}
    </Button>
  );
};

export default DownloadButton; 